import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const DefaultInput = props => (
  <div className="field">
    {props.label && <label className="label">{props.label}</label>}
    <div className="control">
      <input
        className={classnames('profile-input', props.className)}
        type={props.type || 'text'}
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placeholder || ''}
        disabled={props.disabled || false}
      />
    </div>
  </div>
);

DefaultInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default DefaultInput;
